import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_renatomarinho.png",
      alt: "Estratégias Renato Marinho",
    },
    title: "Opere com as melhores estratégias do mercado",

    // String ou array de strings
    text: "A RTB, idealiza  facilitar a vida de investimento das pessoas, buscando nos adaptar às constantes mudanças do mercado financeiro. Utilizamos como nossa aliada a estatística do mercado e algoritmos 100% automatizados desenvolvidos por nossa própria equipe. Possuímos  uma ampla expertise na criação desses algoritmos que são comprovadamente  eficazes e lucrativos. Nossos robôs farão de você um investidor sólido, disciplinado e de sucesso.",
    testimonial: {
      text: "Qualidade, inovação e eficiência, são os pilares de desenvolvimento da RTB.",
      author: {
        name: "Renato Paiva, Head de Estratégias RTB",
        // picture: 'https://ontick-img.s3.sa-east-1.amazonaws.com/raphael_qgdotrader_profile.png',
      },
    },
  },

  strategies: {
    title: "Estratégias Renato Marinho",
    heading: "Tenha acesso aos melhores algoritmos de day trade do mercado.",
    subtitle:
      "Estratégias prontas, desenvolvidas por profissionais. Comece agora mesmo mesmo com apenas alguns cliques.",
  },

  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a extensão RTB.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "Renato Marinho",
    col1: [
      "Idealizamos mudar o dia a dia do investidor de day trade no mercado financeiro, criando algoritmos lucrativos e eficazes, que operam com disciplina sem exitar, tirando o emocional das operações.",
      "Utilizamos como nossa aliada a estatística do mercado e algoritmos 100% automatizados desenvolvidos por nossa própria equipe.",
    ],
    col2: [
      "Nosso time é formado por profissionais experientes como Renato Paiva: profissional com mais de 8 anos de experiência no mercado financeiro atualmente é o head estrategista da RTB.",
    ],
  },

  stats: {
    title: "Alguns números da RTB",
    subtitle:
      "Mais de 5 anos de experiência operando algoritmos no mercado financeiro de forma automatizada.",
    data: [
      {
        value: "+5",
        description: "Anos de atividade",
      },
      {
        value: "+1M",
        description: "Contratos negociados",
      },
      {
        value: "+20Bi",
        description: "Volume financeiro",
      },
    ],
  },

  features: {
    type: 1,
    title: "Por quê utilizar os robôs da RTB",
    subtitle: "Veja quais as principais vantagens em escolher os nossos robôs.",
    data: [
      // {
      //   icon: iconsSet.calendar,
      //   title: "30 dias para testar",
      //   description:
      //     "Teste nossas estratégias e confira a performance em sua conta.",
      // },
      {
        icon: iconsSet.code,
        title: "100% automatizado.",
        description:
          "O uso de inteligência artificial para ajuste de parâmetros das estratégias, melhorando assim a performance a cada dia.",
      },
      // {
      //   icon: iconsSet.group,
      //   title: "Suporte individual",
      //   description:
      //     "Seja fazendo uma ou várias operações por dia, você vai encontrar a estratégia que procura conosco.",
      // },

      ...defaultContent.features.data,
    ],
  },

  // testimonials: [
  //   {
  //     text: "Eu aprendo muito com a Nine. Sempre me atenderam muito bem, passando tranquilidade, compartilhando conhecimento e muito preocupados com o resultado.",
  //     author: "Bruna Maicá da Silveira",
  //     job: "Administradora",
  //     // image_url:
  //     //   "https://ontick-img.s3.sa-east-1.amazonaws.com/flavio-rezende.png",
  //   },
  //   {
  //     text: "O Deividi entende muito de trade! Estou com a Nine desde o começo e já tenho resultados consistentes.",
  //     author: "Jonathan Delgado Reis",
  //     job: "Engenheiro",
  //     // image_url:
  //     //   "https://ontick-img.s3.sa-east-1.amazonaws.com/david-souza.png",
  //   },
  // ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os nossos planos",
  },
};
